import ApiClient from '../helpers/ApiClient';

export const addCounsellor = async ({ name, designation, tele, email }) => {
    try {
        const response = await ApiClient.post(`/itServices/addStudentCounsellor`, { name, designation, tele, email });
        console.log("Response:", response);
        return response;
    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
};

export const getCounsellor = async () => {
    try {
        const response = await ApiClient.get(`/itServices/getStudentCounsellors`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateCounsellor = async ({ id, name, designation, tele, email }) => {
    try {
        const response = await ApiClient.put(
            `/itServices/updateStudentCounsellors/${id}`, { name, designation, tele, email });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
};

export const deleteCounsellor = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/itServices/deleteStudentCounsellor/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}